module.exports = __webpack_public_path__ + "static/forecast/weather/nightheavysnow-9c20ed52f2061cbef6949db55a1851ac.svg";